import React,{useState} from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import ComputerIcon from '@mui/icons-material/Computer';
import RefreshIcon from '@mui/icons-material/Refresh';

const LocationTroubleshoot = () => {
  const [dialogStatus,setDialogStatus] = useState(false);
  return (
    <>
    <button className='btn btn-outline-danger' onClick={()=>setDialogStatus(true)}>Troubleshoot Location</button>
    <Dialog open={dialogStatus} onClose={()=>setDialogStatus(false)} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1 }}>
        📍 How to Enable Location
      </DialogTitle>
      
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          We need your GPS coordinates to verify your punch-in. Please follow the steps for your device:
        </Typography>

        {/* Mobile Section */}
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center', fontWeight: 'bold', color: 'primary.main' }}>
            <SmartphoneIcon sx={{ mr: 1 }} /> Mobile (iOS & Android)
          </Typography>
          <List dense>
            <ListItem>
              <ListItemText 
                primary="1. Check System GPS" 
                secondary="Swipe down (Android) or up (iOS) to ensure 'Location' or 'GPS' is ON." 
              />
            </ListItem>
            <ListItem>
              <ListItemText 
                primary="2. Browser Permission" 
                secondary="Tap the 'Lock 🔒' or 'Settings' icon in your browser address bar and set Location to 'Allow'." 
              />
            </ListItem>
            <ListItem>
              <ListItemText 
                primary="3. iOS Settings" 
                secondary="Go to Settings > Privacy > Location Services. Ensure your browser is allowed 'While Using'." 
              />
            </ListItem>
          </List>
        </Box>

        <Divider sx={{ my: 1 }} />

        {/* Desktop Section */}
        <Box sx={{ mt: 1 }}>
          <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center', fontWeight: 'bold', color: 'primary.main' }}>
            <ComputerIcon sx={{ mr: 1 }} /> Desktop (Windows & Mac)
          </Typography>
          <List dense>
            <ListItem>
              <ListItemText 
                primary="1. Browser Settings" 
                secondary="Click the 'Lock 🔒' icon next to the URL and toggle Location to ON." 
              />
            </ListItem>
            <ListItem>
              <ListItemText 
                primary="2. macOS Privacy" 
                secondary="System Settings > Privacy & Security > Location Services. Enable your browser." 
              />
            </ListItem>
            <ListItem>
              <ListItemText 
                primary="3. Windows Privacy" 
                secondary="Settings > Privacy > Location. Allow desktop apps to access your location." 
              />
            </ListItem>
          </List>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2, justifyContent: 'space-between' }}>
        <Typography variant="caption" color="error">
          * Refresh the page after changing settings.
        </Typography>
        <Button onClick={()=>setDialogStatus(false)} variant="contained" color="primary">
          Got it
        </Button>
      </DialogActions>
    </Dialog>
    </>
  );
};

export default LocationTroubleshoot;